<template lang="pug">
  .contact-us.container
    .row.top-row
      .image-block.xs-12.sm-12.md-6(tabindex="0")
        responsive-image(:media-obj=`image` xs-aspect-key="16x9" sm-aspect-key="8x5" md-aspect-key="3x2" width='605px' height='390px' loading-type="lazy")

      .centered-block.xs-12.md-6.text-center
        .desc-block(tabindex="0" role="region" aria-roledescription="video consultation info")
          .title-wrap
            h2.title.f-secondary.text-color-2.xs-f-grande.sm-f-grande.lg-f-xgrande.max-at-tweak(v-html='title')
          p.subtitle.mt-10.sm-f-xmedium.md-f-medium.lg-f-medium.max-at-tweak(v-html='subtitle')

          .item-wrapper.text-center
            .centered-items
              a.item.sm-f-medium.lg-f-small.max-at-tweak(v-for="item in items" tabindex="0" @click.prevent="onClickOnItem(item)" :href='item.link.url')
                .value-img
                  responsive-image(:media-obj='item.image' xs-aspect-key="1x1" width='90px' height='90px' loading-type="lazy")

                .value-title
                  .hard-link.btn-reset
                    p.upper.cta-color-2.xs-f-xxsmall.md-f-small.max-at-tweak {{item.link.text}}
</template>
<script>
  import { mapMutations } from 'vuex';

  import ResponsiveImage from '@components/ResponsiveImage';

  export default {
    name: 'ContactUs',

    components: {
      ResponsiveImage,
    },

    props: {
      title: {
        type: String,
        default: '',
      },
      subtitle: {
        type: String,
        default: '',
      },
      image: {
        type: Object,
        default() {
          return {};
        },
      },
      items: {
        type: Array,
        default() {
          return [];
        },
      },
    },

    computed: {
      isForEmbedding() {
        if (!window) {
          return false;
        }

        let urlParams = new URLSearchParams(window.location.search);
        return !!urlParams.get('embed');
      },
    },

    methods: {
      ...mapMutations('chatWidget', ['setDataForOpeningChat']),

      getActualUrl(item) {
        if (this.isForEmbedding) {
          let newUrl = new URL(window.location.href);

          if (item.opensChat) {
            newUrl.searchParams.set('embedRedirect', 'chat');
          } else {
            newUrl.searchParams.set('embedRedirect', item.link.url.replace(/[/+:]/g, ''));
          }

          newUrl.toString();

          return newUrl.toString();
        } else {
          return item.link.url;
        }
      },

      onClickOnItem(item) {
        if (item.opensChat && !this.isForEmbedding) {
          this.setDataForOpeningChat({ eventName: item.mrEventName });
          this.trackMREvent(item.mrEventName);
        } else {
          this.trackMREventAndRedirect(item.mrEventName, this.getActualUrl(item));
        }
      },
    },
  };
</script>
<style lang="stylus">
  .contact-us
    background-color ui-color-3
    margin 2em auto
    max-width 1300px
    height 390px
    display block

    .centered-block
      height 390px
      overflow hidden

    .desc-block
      height 100%
      position relative
      padding 27px 36px

      .title-wrap
        padding 0px 6.5%

        @media mq-desktop-tweak-plus
          padding 0px 8%

      .item-wrapper
        padding-left 50%
        padding-top 36px
        width 100%
        min-width 540px
        position relative

        @media mq-desktop-tweak-plus
          min-width 780px

        .centered-items
          transform translateX(-50%)
          width 100%
          display flex

          .item
            width 33.333%

            .value-img
              margin auto
              width 90px
              height 90px

              .responsive-image > img
                height 100%

            .value-title
              margin-top 10px
              padding 0px 8%

    .image-block
      height 100%
      overflow hidden
      max-height 390px

      .responsive-image > img
          min-height 390px
          min-width 650px
          transform translateX(-50%)
          margin-left 50%

  @media mq-tablet-less
    .contact-us
      min-height 477px
      max-height 600px
      height 15%
      overflow hidden

      .top-row
        width 100%

      .centered-block
        height unset

      .desc-block
        padding 0px
        padding-top 24px
        padding-bottom 24px

        .title-wrap
          padding 0px

        .title
        .subtitle
          text-align left
          margin-left 36px

          @media only screen and (max-width: 320px)
            margin-left 6% !important
            margin-right 6% !important

      .image-block
        max-height 16em
        height 24em

        .responsive-image
          width 100%
          position absolute

          > img
            height unset
            min-height unset
            width 100%
            min-width 390px
            transform translate(-50%, -100%)
            margin-top 50%

      .item-wrapper
        padding-left 0px !important
        padding-top 24px !important
        min-width unset !important

        .centered-items
          width 100% !important
          transform unset !important

          .item
            width 120px

            .value-img
              width 64px !important
              height  64px !important

              .responsive-image > img
                height  100%

            .value-title
              margin-top  10px !important

  @media only screen and (max-width: 448px)
    .image-block
      .responsive-image
        > img
          transform translateX(-50%) !important
          margin-top unset !important
</style>